import React from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ProductCard } from '../components/ProductCard';
import { products } from '../data/products';
const categoryMap: Record<string, {
  title: string;
  desc: string;
  filter: (p: any) => boolean;
}> = {
  'lawn-mowers': {
    title: 'Yarbo Robotic Lawn Mowers',
    desc: 'Wire-free, autonomous robotic mowing for properties of every size. Available as complete systems and individual modules.',
    filter: p => p.season.includes('Lawn Care') && (p.category === 'Complete Systems' || p.category === 'Modules')
  },
  'snow-blowers': {
    title: 'Yarbo Robotic Snow Blowers',
    desc: 'True 2-stage autonomous snow clearing for driveways, walkways, and large properties.',
    filter: p => p.season.includes('Snow Removal') && (p.category === 'Complete Systems' || p.category === 'Modules')
  },
  'leaf-blowers': {
    title: 'Yarbo Robotic Leaf Blowers',
    desc: 'High-force robotic leaf and debris clearing for wooded lots and large properties.',
    filter: p => p.season.includes('Leaf Cleanup') && (p.category === 'Complete Systems' || p.category === 'Modules')
  },
  bundles: {
    title: 'Yarbo Bundles',
    desc: 'Multi-module systems shipped with the Yarbo Core for year-round yard automation.',
    filter: p => p.category === 'Bundles'
  },
  modules: {
    title: 'Yarbo Modules',
    desc: 'Module-only products for customers who already own or are purchasing a compatible Yarbo Core.',
    filter: p => p.category === 'Modules'
  },
  accessories: {
    title: 'Yarbo Accessories',
    desc: 'Blades, antennas, mounts, grease, and replacement parts for Yarbo Y Series systems.',
    filter: p => p.category === 'Accessories'
  }
};
export function Category() {
  const {
    slug
  } = useParams<{
    slug: string;
  }>();
  const data = categoryMap[slug || ''];
  if (!data) return <Navigate to="/shop" replace data-id="element-262" />;
  const categoryProducts = products.filter(data.filter);
  return <div className="bg-gray-50 min-h-screen" data-id="element-263">
      <div className="bg-white border-b border-gray-200" data-id="element-264">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-id="element-265">
          <motion.h1 initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-3xl md:text-4xl font-extrabold text-yarbo-dark mb-2" data-id="element-266">
            {data.title}
          </motion.h1>
          <p className="text-gray-600 max-w-3xl" data-id="element-267">{data.desc}</p>
          <div className="mt-4 text-sm text-gray-500 font-medium" data-id="element-268">
            {categoryProducts.length} product
            {categoryProducts.length !== 1 ? 's' : ''}
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-id="element-269">
        {categoryProducts.length > 0 ? <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6" data-id="element-270">
            {categoryProducts.map((p, idx) => <motion.div key={p.id} initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: Math.min(idx * 0.04, 0.4)
        }} data-id="element-271">
                <ProductCard product={p} compact={categoryProducts.length > 8} data-id="element-272" />
              </motion.div>)}
          </div> : <div className="text-center py-20 text-gray-500" data-id="element-273">
            No products in this category yet.
          </div>}
      </div>
    </div>;
}